/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from "react"
import { Link } from "gatsby"
import { Popover, Transition } from "@headlessui/react"
import { HiOutlineX } from "react-icons/hi"
import { VscMenu } from "react-icons/vsc"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import ButtonModal from "./modal"
import MenuTopRow from "./menuTopRow"

export default function MainMenu({
  companyTitle,
  companySubTitle,
  phone,
  address,
  bgColor,
}) {
  const menuItems = useSiteMetadata().datoCmsCompany.menuItems.filter(
    item => item.isActive,
  )
  return (
    <div className="relative">
      <MenuTopRow phone={phone} address={address} />
      <div className={`relative ${bgColor}`}>
        <Popover>
          <div className="mx-auto px-4 sm:px-8 xl:px-24">
            <nav
              className="relative flex flex-row justify-between items-center h-24 text-white"
              aria-label="Global"
            >
              <div className="flex items-center flex-1">
                <div className="flex items-center justify-between w-full lg:w-auto">
                  <Link
                    to="/"
                    className="self-center font-playfaird text-white"
                  >
                    <div className="font-medium text-3xl whitespace-nowrap">
                      {companyTitle}
                    </div>
                    <div className="font-normal text-center whitespace-nowrap">
                      {companySubTitle}
                    </div>
                  </Link>

                  <div className="-mr-2 flex items-center lg:hidden">
                    <Popover.Button className="bg-slate-50 rounded-sm p-4 inline-flex items-center justify-center text-slate-900 hover:text-slate-800 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-200">
                      <span className="sr-only">Open main menu</span>
                      <VscMenu aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
              </div>
              <div className="hidden lg:flex lg:space-x-6">
                {menuItems.map(item => (
                  <Link
                    key={item.id}
                    to={item.to}
                    className="font-medium text-white hover:text-slate-50 tracking-wider"
                    activeClassName="border-b-2 border-amber-200"
                  >
                    {item.title}
                  </Link>
                ))}
              </div>
              <div className="hidden sm:block ml-4 xl:ml-12">
                <div className="ml-4 xl:ml-12">
                  <ButtonModal buttonText="Book Now" />
                </div>
              </div>
            </nav>
          </div>

          <Transition
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top-right lg:hidden"
            >
              <div className="rounded-sm shadow-md bg-white ring-1 ring-black ring-opacity-5">
                <div className="px-5 pt-4 flex items-center justify-between">
                  <div>
                    <Link to="/" className="self-center font-playfaird">
                      <div className="font-medium text-3xl whitespace-nowrap">
                        {companyTitle}
                      </div>
                      <div className="font-normal text-center whitespace-nowrap">
                        {companySubTitle}
                      </div>
                    </Link>
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-slate-400 hover:text-slate-500 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-slate-500">
                      <span className="sr-only">Close menu</span>
                      <HiOutlineX className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="px-2 pt-2 pb-3">
                  {menuItems.map(item => (
                    <Link
                      key={item.id}
                      to={item.to}
                      className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-slate-900 hover:bg-slate-50"
                      activeClassName="border-b-2 border-amber-200"
                    >
                      {item.title}
                    </Link>
                  ))}
                  {/* <ButtonModal className="my-3 ml-3" buttonText="Book Now" /> */}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    </div>
  )
}
